import gql from 'graphql-tag'

import { Fragment } from './fragment'

export const mutation = gql`
  ${Fragment}
  mutation updateOffer($id: Int!, $fields: loans_offer_set_input!) {
    record: update_loans_offer_by_pk(pk_columns: {id: $id}, _set: $fields) {
      ...OfferForm
    }
  }
`

export default mutation
